<template>
  <div class="online-user-video">
    <div class="online-user-video-video">
      <div>
<!--        <video-->
<!--            v-if="userInfo.showVideo"-->
<!--            controls="controls"-->
<!--            muted="muted"-->
<!--            :id="userInfo.userId"-->
<!--            disablePictureInPicture="true"-->
<!--        ></video>-->
        <lw-two-screen-player
            v-if="userInfo.showVideo"
            :player-id="userInfo.userId"
            :picture-count="userInfo.pictureCount"
            @set-player-muted="(e) => setPlayerMuted(e)"
            @set-player-volume="(e) => setPlayerVolume(e)"
        >
        </lw-two-screen-player>
        <div class="online-user-video-video-default" v-else>
          <img src="../../assets/images/video-error.png" alt="暂无数据"/>
          <p>{{ userInfo.videoDefaultText }}</p>
        </div>
      </div>
      <p>{{ userInfo.displayName }}<!-- (<span>{{userInfo.identitySuffix}}</span>) --></p>
    </div>
  </div>
</template>

<script>
import RTCClient from "../../rtc/RTCClient";

export default {
  name: "OnlineUserVideo",
  props: {
    userInfo: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    /**
     * 设置在线人员的播放器静音与否
     */
    setPlayerMuted(playerObj) {
      RTCClient.instance.muteRemoteAudioPlaying(playerObj.playerId, playerObj.muted)
    },

    /**
     * 设置在线人员的播放器的订阅音量
     */
    setPlayerVolume(playerObj) {
      RTCClient.instance.setAudioVolume(playerObj.playerId, playerObj.volume)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index";
.online-user-video {
  &-video {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 100%;
    /* video 169 +30*/
    height: 100%;
    padding: 0 computer(10px) computer(10px) computer(5px);

    > div {
      width: calc(100% - #{computer(15px)});
      height: calc(100% - #{computer(35px)});
      video {
        height: 100%;
        width: 100%;
        display: block;
        background: $color_font-black;
      }

      /* 播放按钮 */
      video::-webkit-media-controls-play-button {
        display: none;
      }

      /* 进度条 */
      video::-webkit-media-controls-timeline {
        display: none;
      }

      /* 观看的当前时间 */
      video::-webkit-media-controls-current-time-display {
        display: none;
      }

      /* 剩余时间 */
      video::-webkit-media-controls-time-remaining-display {
        display: none;
      }

      /* 音量按钮 */
      /*video::-webkit-media-controls-mute-button {*/
      /*    display: none;*/
      /*}*/

      /*video::-webkit-media-controls-toggle-closed-captions-button {*/
      /*    display: none;*/
      /*}*/

      /*!* 音量的控制条 *!*/
      /*video::-webkit-media-controls-volume-slider {*/
      /*    display: none;*/
      /*}*/
    }

    p {
      height: computer(25px);
      line-height: computer(25px);
      text-align: center;
      width: 100%;
      padding: 0 computer(10px) 0;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // 禁止元素的文字被选中
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;

      span {
        color: $color_font-light;
        font-size: computer(14px);
      }
    }

    ::v-deep .player-container{
      width: 100%;
      height: 100%;
      .main-picture-container {
        width: 100%;
        height: 100%;
        video {
          height: 100% !important;
        }
      }
    }

    &-default {
      background: #000;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: computer(14px);
      position: relative;

      img {
        display: block;
        width: 25%;
      }

      p {
        color: #666666;
        margin-top: computer(5px);
      }
    }
  }

  .student-disable {
    //opacity: 0.2;
    cursor: default;
  }

  .el-lw-modal-mask {
    ::v-deep.el-lw-modal-b-header {
      height: 0px !important;
      overflow: hidden;
    }
  }

  &-modal {

    &-body {
      width: 100%;
      height: 400px;

      &-video {

      }
    }

    &-footer {
      padding: 10px 20px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      border-top: 1px solid #e9e9e9;

      &-left {
        display: flex;

      }

      &-right {
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }

  }

}
</style>
